import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import AddStoreFeaturedVideo from "./AddStoreFeaturedVideo";
import StoreFeatureVideoTable from "./StoreFeatureVideoTable";
import getAccess from "../../../utils/getAccess";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const StoreFeaturedVideo = () => {
  const d = getAccess();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          sx={{ width: "100%" }}
        >
          <Tab
            label="All Store Featured Video"
            sx={{ width: "100%" }}
            {...a11yProps(0)}
          />

          {(d?.accessForTab?.includes("readWrite") ||
            d?.access?.includes("all")) && (
              <Tab
                label="Add Store Featured Video"
                sx={{ width: "100%" }}
                {...a11yProps(1)}
              />
            )}
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
        <StoreFeatureVideoTable />
      </TabPanel>

      <TabPanel value={value} index={1}>
        {(d?.accessForTab?.includes("readWrite") ||
          d?.access?.includes("all")) && (
            <AddStoreFeaturedVideo />
          )}
      </TabPanel>
    </Box>
  );
};

export default StoreFeaturedVideo;
